/**
 * @type {import('angular').IController}
 */
export default class {
	// Bindings
	/** @type {string} */
	icon = '';

	/** @type {boolean} */
	invertDir = false;

	/** @type {'primary' | 'default' | 'success' | 'warning' | 'danger' | 'muted'} */
	type = 'default';

	/** @type {string} */
	tooltip = '';

	/** @type {boolean} */
	isOpen = true;

	/** @type {boolean} */
	isLoading = false;

	/** @type {boolean} */
	isFullscreen = false;

	/** @type {boolean} */
	preventToggling = false;

	/** @type {boolean} */
	allowFullscreen = false;

	/** @type {boolean} */
	allowCollapse = true;

	/** @type {?Function} */
	onAdd = null;

	/** @type {?Function} */
	onRefresh = null;

	/** @type {?Function} */
	onOpened = null;

	/** @type {?Function} */
	onClosed = null;

	/** @type {?Function} */
	onFullscreenChange = null;

	/** @type {?Function} */
	onClick = null;

	/** @type {any} */
	options = {};

	// Variables
	/** @type {any} */
	panelType = {};

	/** @type {string} */
	textClass = '';

	refresh = null;

	classes() {
		return {
			...this.panelType,
			fullscreen: this.isFullscreen,
		};
	}

	titleClick() {
		if (!this.preventToggling) {
			this.isOpen = !this.isOpen;
			if (this.isOpen && this.onOpened) {
				this.onOpened();
			}
			else if (this.onClosed) {
				this.onClosed();
			}
		}
		else if (this.onClick) {
			this.onClick();
		}
	}

	toggleFullscreen() {
		this.isFullscreen = !this.isFullscreen;
		if (this.onFullscreenChange) {
			this.onFullscreenChange();
		}
	}

	$onInit() {
		// Bindings
		this.icon ??= '';
		this.invertDir ??= false;
		this.type ??= 'default';
		this.tooltip ??= '';
		this.isOpen ??= true;
		this.isLoading ??= false;
		this.preventToggling ??= false;
		this.onAdd ??= null;
		this.onRefresh ??= null;
		this.allowFullscreen ??= false;
		this.allowCollapse ??= true;
		this.isFullscreen ??= false;

		// Variables
		this.panelType = { [`panel-${this.type}`]: true };

		this.textClass = `text-${this.type}`;
	}
}
